import { z } from 'zod'
import { AsyncFn } from '../../common'
import { guidSchema } from '../../contracts/_common'
import { ForCompany, ForCompanyUser } from '../Company/Company'
import { bzOptional } from '../common-schemas'

export const jobTypeCorrectionPreviewSchema = z.object({
  jobGuid: guidSchema,
  jobTypeGuid: guidSchema,
  jobLifecycleStatusGuid: bzOptional(guidSchema),
  summary: bzOptional(z.string().max(10000)),
})

export const jobTypeCorrectionApplySchema = jobTypeCorrectionPreviewSchema.extend({
  commandGuid: guidSchema,
  fingerprint: z.string().length(64),
  note: bzOptional(z.string().max(2000)),
})

export type JobTypeCorrectionPreviewInput = z.infer<typeof jobTypeCorrectionPreviewSchema>
export type JobTypeCorrectionApplyInput = z.infer<typeof jobTypeCorrectionApplySchema>
export type JobTypeCorrectionPreview = {
  fingerprint: string
  current: { type: string; jobClass: string; pipeline: string; status: string }
  destination: { jobTypeGuid: string; type: string; jobClass: string; pipeline: string; status?: string }
  statusOptions: { jobLifecycleStatusGuid: string; name: string }[]
  changes: string[]
  blockers: string[]
  needsSummary: boolean
  ready: boolean
}
export type JobTypeCorrectionResult = { commandGuid: string; jobGuid: string }
export type JobTypeCorrectionPreviewer = AsyncFn<
  ForCompanyUser<JobTypeCorrectionPreviewInput> & { canManageTechnicianPerformance: boolean },
  JobTypeCorrectionPreview
>
export type JobTypeCorrectionApplier = AsyncFn<
  ForCompanyUser<JobTypeCorrectionApplyInput> & { canManageTechnicianPerformance: boolean },
  JobTypeCorrectionResult
>
export type JobClassificationRevisionReader = AsyncFn<
  ForCompany<{ jobGuid: string }>,
  { classificationRevision: number }
>
